import React,{useContext} from 'react';
import Logo from '../../../assets/sernapesca-caletaenlinea-flags.png';
import UserIcon from '../../../assets/user-icon.png';
import ChevronDown from '../../../assets/chevron-down.svg';
import MenuIcon from '../../../assets/menu-icon.svg';
import CloseIcon from '../../../assets/icon-close.svg';
import {uiContext} from '../../../components/common/';
import './HeaderAdmin.scss';

export function HeaderAdmin() {
  /**
   * Componente Cabezera del admin
   */
  const {showMenu, setShowMenu} = useContext(uiContext);
  return (
    <header className='header'>
      <div className='container-logo'>
        <img src={Logo} alt="Logo" />
      </div>
      <div className='container-admin'>
        <h1>Panel administrativo</h1>
        <div className='container-right'>
          <img src={UserIcon} alt="User icon" className='user' />
          <p>Admin</p>
          <img src={ChevronDown} alt="Chevron down" className='chevron' />
        </div>
      </div>
      <div 
        className='container-menu'
        onClick={()=> setShowMenu(!showMenu)}>
        <img src={showMenu ? CloseIcon : MenuIcon} alt="Menu icon" />
      </div>
    </header>
  )
}